import { render, staticRenderFns } from "./EstDes5.vue?vue&type=template&id=1b596df4&scoped=true&"
import script from "./EstDes5.vue?vue&type=script&lang=js&"
export * from "./EstDes5.vue?vue&type=script&lang=js&"
import style0 from "./EstDes5.vue?vue&type=style&index=0&id=1b596df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b596df4",
  null
  
)

export default component.exports